import { render, staticRenderFns } from "./recom-mendation.vue?vue&type=template&id=b01148fe&scoped=true"
import script from "./recom-mendation.vue?vue&type=script&lang=js"
export * from "./recom-mendation.vue?vue&type=script&lang=js"
import style0 from "./recom-mendation.vue?vue&type=style&index=0&id=b01148fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01148fe",
  null
  
)

export default component.exports